<template>
	<v-dialog
		v-model="dialogOtp"
		max-width="520"
		persistent
	>
		<v-card>
			<v-card-text class="d-flex align-center justify-space-between py-4">
				<h3 class="">Kode OTP Keamanan</h3>
				<v-btn
					icon
					@click="cancelSaveDialog"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-text>
			<v-card-text>
				<v-row justify="center">
					<v-col cols="12" class="text-center font-weight-bold mb-2">
						Masukkan 6 digit kode keamanan yang dikirim<br>melalui pesan WA Anda.
					</v-col>

					<v-col cols="12" lg="10" class="text-center mb-2 col-otp">
						<v-alert
							dense
							text
							:type="(otpError || errorValidation['otp'] !== undefined) ? 'error' : 'success'"
							class="mb-50 text-left"
							transition="scale-transition"
							v-if="otpMessage !== '' || errorValidation['otp'] !== undefined"
						>
							<template v-if="errorValidation['otp'] !== undefined">{{ errorValidation['otp'] }}</template>
							<template v-else-if="otpMessage !== ''">{{ otpMessage }}</template>
						</v-alert>

						<div @keyup="changeFocusInput">
							<v-row class="">
								<v-col cols="2 px-1">
									<v-text-field ref="otp0" v-model="otp[0]" @input="moveToNextField(0)" outlined full-width autofocus  x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @paste="handlePasteEvent($event)" @keypress="handleKeyDown($event, 0)"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp1" v-model="otp[1]" @input="moveToNextField(1)" outlined full-width x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @paste="handlePasteEvent($event)" @keypress="handleKeyDown($event, 1)"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp2" v-model="otp[2]" @input="moveToNextField(2)" outlined full-width x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @paste="handlePasteEvent($event)" @keypress="handleKeyDown($event, 2)"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp3" v-model="otp[3]" @input="moveToNextField(3)" outlined full-width x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @paste="handlePasteEvent($event)" @keypress="handleKeyDown($event, 3)"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp4" v-model="otp[4]" @input="moveToNextField(4)" outlined full-width x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @paste="handlePasteEvent($event)" @keypress="handleKeyDown($event, 4)"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp5" v-model="otp[5]" @input="moveToNextField(5)" outlined full-width x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @paste="handlePasteEvent($event)" @keypress="handleKeyDown($event, 5)"></v-text-field>
								</v-col>
							</v-row>
						</div>
					</v-col>

					<v-col cols="12" lg="10" class="text-center mb-2 px-0">
						<p class="mb-0">Belum menerima kode OTP?</p>
						<Timer :valDate="new Date(otpLastSent)" @action="changeTimer" class="font-weight-bold font-size-16 py-2" v-show="(this.otpCount == '1')"></Timer>
						<v-btn 
							text
							tile
							color="primary"
							class="py-0"
							:disabled="(this.otpCount == '1')"
							@click="getNewOTPCode"><v-icon dense class="mr-1">mdi-refresh</v-icon>Kirim Ulang Kode OTP</v-btn>
					</v-col>

					<v-col cols="12" lg="10" class="text-center mb-2 px-0">
						<v-btn
							rounded
							color="primary"
							:loading="btnLoadingProses"
							:disabled="!isValidOTP"
							@click="verifyInputOTP"
						>
							Proses Pencairan Saldo
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Timer from './Timer';

export default {
	components: { Timer },
	data () {
		return {
			dialogOtp: false,
			otp: ['','','','','',''],
			isValidOTP: false,
			otpError: false,
			otpMessage: '',
			otpCount: '',
			otpLastSent: null,
			otpTimer: null,
			loadign_otp_process: false,
			member_otp_code: '',
			btnLoadingProses: false,
			currentItem: 0,
		}
	},
	computed: {
		...mapState('ewallet', ['errorValidation']),
	},
	watch: {
    currentItem: {
			handler(value, oldValue) {
        if (value !== oldValue) {
        this.focusInput(value);
        }
			},
			immediate: true
    },

		otp: {
			handler(value) {
				let strOTP = value.join('')
        if (strOTP.length == 6 && (!isNaN(parseInt(strOTP)/2))) {
         this.isValidOTP = true
        } else {
					this.isValidOTP = false
				}
			},
			immediate: true
    }
	},
	methods: {
		...mapMutations('ewallet', ['clearErrorValidation']),
		...mapActions('ewallet', ['getNewOTP', 'verifyOTP']),

		changeTimer(val) {
			this.otpCount = val
		},
		modalHide() {
			this.dialogOtp = false
		},
		loadingButton() {
			this.btnLoadingProses = true
		},
		stopLoading() {
			this.btnLoadingProses = false
		},
		reset() {
			this.otp = ['','','','','','']
			// this.otp[0] = ''
			// this.otp[1] = ''
			// this.otp[2] = ''
			// this.otp[3] = ''
			// this.otp[4] = ''
			// this.otp[5] = ''

			// this.$refs['otp0'].value = ''
			// this.$refs['otp1'].value = ''
			// this.$refs['otp2'].value = ''
			// this.$refs['otp3'].value = ''
			// this.$refs['otp4'].value = ''
			// this.$refs['otp5'].value = ''
			
		},
		async modalShow() {
			this.dialogOtp = await true
			this.member_otp_code = await ''
			this.otp = await []
			this.otpMessage = await ''
			this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
			this.getNewOTPCode()
			this.otpError = false
		},

		handleKeyDown(event, index) {
			let keyCode = (event.keyCode ? event.keyCode : event.which);
			this.currentItem = index

			// && (event.ctrlKey && (event.key === 'v' || event.key === 'V'))
			if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 9 && keyCode !== 37 && keyCode !== 39 && keyCode !== 46) {
				event.preventDefault();
			}
		},

		handlePasteEvent(){
			navigator.clipboard
          .readText()
          .then((clipText) => {
            if (!isNaN(clipText/2)) {
              // const otpText = clipText.split('');
							this.otp = []
							for (let i = 0; i < clipText.length; i++) {
								this.$nextTick(() => {
									this.otp.push(parseInt(clipText[i]));
									// this.$refs['otp' + i].value = parseInt(clipText[i]);
								});
							}

							if (clipText.length == 6) this.$refs['otp5'].focus();
							else if (clipText.length < 6) this.$refs['otp' + clipText.length].focus();
            } else {
							this.reset();
							this.$refs['otp0'].focus();
						}
          });
    },

		getInput(id) {
        const input = this.$refs[`otp${id}`];
        return input;
    },
    changeFocusInput(event) {
        const key_code = {
            left: 37,
            right: 39
        };
        
        let nextItem = this.currentItem;
        if (event.keyCode == key_code.left) {
            nextItem -= 1;
        } else if (event.keyCode == key_code.right || event.keyCode == 8) {
            nextItem += 1;
        }
        
        if (this.getInput(nextItem)) {
            this.currentItem = nextItem;
        }    
    },
    focusInput(id) {
        const input = this.getInput(id);
        if (input) {
            input.focus();
        }
    },

		getNewOTPCode() {
			if (this.errorValidation.length > 0) this.clearErrorValidation()
			if (this.otpCount == '' || this.otpCount == '0') {
				this.btnLoadingProses = true
				let params = {
					type: 'ewallet'
				}
				this.getNewOTP(params)
					.then(()=> {
						this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
						this.otpMessage = 'Kode otp keamanan telah berhasil dikirimkan.'
						this.otpError = false
						setTimeout(() => {
							this.otpMessage = ''
							this.btnLoadingProses = false
						}, 6000);
					})
					.catch((err) => {
						this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
						this.otpMessage = (err.data.message !== undefined) ? err.data.message : ''
						this.otpError = true
						this.btnLoadingProses = false
					})
			}
		},

		moveToNextField(index) {
      const nextIndex = index + 1
      if (this.$refs['otp' + nextIndex] !== undefined) this.$refs['otp' + nextIndex].focus()
    },

		cancelSaveDialog() {
			this.otpMessage = ''
			this.otpError = false
			this.otp = []
			this.dialogOtp = false
			this.btnLoadingProses = false
		},

		async verifyInputOTP() {
			this.btnLoadingProses = await true

			this.$emit('action', this.otp.join(''))
			setTimeout(() => {
				this.btnLoadingProses = false
			}, 6000);
		}
	},
	

	mounted() {
		
	},
};
</script>